export const THEME_DICTIONARY_LOADERS = {
    books: {
        ar: () => import('../books/i18n/ar.js'),
        be: () => import('../books/i18n/be.js'),
        bg: () => import('../books/i18n/bg.js'),
        bs: () => import('../books/i18n/bs.js'),
        cs: () => import('../books/i18n/cs.js'),
        de: () => import('../books/i18n/de.js'),
        el: () => import('../books/i18n/el.js'),
        en: () => import('../books/i18n/en.js'),
        es: () => import('../books/i18n/es.js'),
        et: () => import('../books/i18n/et.js'),
        fr: () => import('../books/i18n/fr.js'),
        hr: () => import('../books/i18n/hr.js'),
        hu: () => import('../books/i18n/hu.js'),
        it: () => import('../books/i18n/it.js'),
        lt: () => import('../books/i18n/lt.js'),
        lv: () => import('../books/i18n/lv.js'),
        mk: () => import('../books/i18n/mk.js'),
        pl: () => import('../books/i18n/pl.js'),
        pt: () => import('../books/i18n/pt.js'),
        ro: () => import('../books/i18n/ro.js'),
        ru: () => import('../books/i18n/ru.js'),
        sk: () => import('../books/i18n/sk.js'),
        sl: () => import('../books/i18n/sl.js'),
        sq: () => import('../books/i18n/sq.js'),
        sr: () => import('../books/i18n/sr.js'),
        uk: () => import('../books/i18n/uk.js'),
    },
    homeware: {
        ar: () => import('../homeware/i18n/ar.js'),
        be: () => import('../homeware/i18n/be.js'),
        bg: () => import('../homeware/i18n/bg.js'),
        bs: () => import('../homeware/i18n/bs.js'),
        cs: () => import('../homeware/i18n/cs.js'),
        de: () => import('../homeware/i18n/de.js'),
        el: () => import('../homeware/i18n/el.js'),
        en: () => import('../homeware/i18n/en.js'),
        es: () => import('../homeware/i18n/es.js'),
        et: () => import('../homeware/i18n/et.js'),
        fr: () => import('../homeware/i18n/fr.js'),
        hr: () => import('../homeware/i18n/hr.js'),
        hu: () => import('../homeware/i18n/hu.js'),
        it: () => import('../homeware/i18n/it.js'),
        lt: () => import('../homeware/i18n/lt.js'),
        lv: () => import('../homeware/i18n/lv.js'),
        mk: () => import('../homeware/i18n/mk.js'),
        pl: () => import('../homeware/i18n/pl.js'),
        pt: () => import('../homeware/i18n/pt.js'),
        ro: () => import('../homeware/i18n/ro.js'),
        ru: () => import('../homeware/i18n/ru.js'),
        sk: () => import('../homeware/i18n/sk.js'),
        sl: () => import('../homeware/i18n/sl.js'),
        sq: () => import('../homeware/i18n/sq.js'),
        sr: () => import('../homeware/i18n/sr.js'),
        uk: () => import('../homeware/i18n/uk.js'),
    },
    tech: {
        ar: () => import('../tech/i18n/ar.js'),
        be: () => import('../tech/i18n/be.js'),
        bg: () => import('../tech/i18n/bg.js'),
        bs: () => import('../tech/i18n/bs.js'),
        cs: () => import('../tech/i18n/cs.js'),
        de: () => import('../tech/i18n/de.js'),
        el: () => import('../tech/i18n/el.js'),
        en: () => import('../tech/i18n/en.js'),
        es: () => import('../tech/i18n/es.js'),
        et: () => import('../tech/i18n/et.js'),
        fr: () => import('../tech/i18n/fr.js'),
        hr: () => import('../tech/i18n/hr.js'),
        hu: () => import('../tech/i18n/hu.js'),
        it: () => import('../tech/i18n/it.js'),
        lt: () => import('../tech/i18n/lt.js'),
        lv: () => import('../tech/i18n/lv.js'),
        mk: () => import('../tech/i18n/mk.js'),
        pl: () => import('../tech/i18n/pl.js'),
        pt: () => import('../tech/i18n/pt.js'),
        ro: () => import('../tech/i18n/ro.js'),
        ru: () => import('../tech/i18n/ru.js'),
        sk: () => import('../tech/i18n/sk.js'),
        sl: () => import('../tech/i18n/sl.js'),
        sq: () => import('../tech/i18n/sq.js'),
        sr: () => import('../tech/i18n/sr.js'),
        uk: () => import('../tech/i18n/uk.js'),
    },
    supplements: {
        ar: () => import('../supplements/i18n/ar.js'),
        be: () => import('../supplements/i18n/be.js'),
        bg: () => import('../supplements/i18n/bg.js'),
        bs: () => import('../supplements/i18n/bs.js'),
        cs: () => import('../supplements/i18n/cs.js'),
        de: () => import('../supplements/i18n/de.js'),
        el: () => import('../supplements/i18n/el.js'),
        en: () => import('../supplements/i18n/en.js'),
        es: () => import('../supplements/i18n/es.js'),
        et: () => import('../supplements/i18n/et.js'),
        fr: () => import('../supplements/i18n/fr.js'),
        hr: () => import('../supplements/i18n/hr.js'),
        hu: () => import('../supplements/i18n/hu.js'),
        it: () => import('../supplements/i18n/it.js'),
        lt: () => import('../supplements/i18n/lt.js'),
        lv: () => import('../supplements/i18n/lv.js'),
        mk: () => import('../supplements/i18n/mk.js'),
        pl: () => import('../supplements/i18n/pl.js'),
        pt: () => import('../supplements/i18n/pt.js'),
        ro: () => import('../supplements/i18n/ro.js'),
        ru: () => import('../supplements/i18n/ru.js'),
        sk: () => import('../supplements/i18n/sk.js'),
        sl: () => import('../supplements/i18n/sl.js'),
        sq: () => import('../supplements/i18n/sq.js'),
        sr: () => import('../supplements/i18n/sr.js'),
        uk: () => import('../supplements/i18n/uk.js'),
    },
    coffee: {
        ar: () => import('../coffee/i18n/ar.js'),
        be: () => import('../coffee/i18n/be.js'),
        bg: () => import('../coffee/i18n/bg.js'),
        bs: () => import('../coffee/i18n/bs.js'),
        cs: () => import('../coffee/i18n/cs.js'),
        de: () => import('../coffee/i18n/de.js'),
        el: () => import('../coffee/i18n/el.js'),
        en: () => import('../coffee/i18n/en.js'),
        es: () => import('../coffee/i18n/es.js'),
        et: () => import('../coffee/i18n/et.js'),
        fr: () => import('../coffee/i18n/fr.js'),
        hr: () => import('../coffee/i18n/hr.js'),
        hu: () => import('../coffee/i18n/hu.js'),
        it: () => import('../coffee/i18n/it.js'),
        lt: () => import('../coffee/i18n/lt.js'),
        lv: () => import('../coffee/i18n/lv.js'),
        mk: () => import('../coffee/i18n/mk.js'),
        pl: () => import('../coffee/i18n/pl.js'),
        pt: () => import('../coffee/i18n/pt.js'),
        ro: () => import('../coffee/i18n/ro.js'),
        ru: () => import('../coffee/i18n/ru.js'),
        sk: () => import('../coffee/i18n/sk.js'),
        sl: () => import('../coffee/i18n/sl.js'),
        sq: () => import('../coffee/i18n/sq.js'),
        sr: () => import('../coffee/i18n/sr.js'),
        uk: () => import('../coffee/i18n/uk.js'),
    },
    toys: {
        ar: () => import('../toys/i18n/ar.js'),
        be: () => import('../toys/i18n/be.js'),
        bg: () => import('../toys/i18n/bg.js'),
        bs: () => import('../toys/i18n/bs.js'),
        cs: () => import('../toys/i18n/cs.js'),
        de: () => import('../toys/i18n/de.js'),
        el: () => import('../toys/i18n/el.js'),
        en: () => import('../toys/i18n/en.js'),
        es: () => import('../toys/i18n/es.js'),
        et: () => import('../toys/i18n/et.js'),
        fr: () => import('../toys/i18n/fr.js'),
        hr: () => import('../toys/i18n/hr.js'),
        hu: () => import('../toys/i18n/hu.js'),
        it: () => import('../toys/i18n/it.js'),
        lt: () => import('../toys/i18n/lt.js'),
        lv: () => import('../toys/i18n/lv.js'),
        mk: () => import('../toys/i18n/mk.js'),
        pl: () => import('../toys/i18n/pl.js'),
        pt: () => import('../toys/i18n/pt.js'),
        ro: () => import('../toys/i18n/ro.js'),
        ru: () => import('../toys/i18n/ru.js'),
        sk: () => import('../toys/i18n/sk.js'),
        sl: () => import('../toys/i18n/sl.js'),
        sq: () => import('../toys/i18n/sq.js'),
        sr: () => import('../toys/i18n/sr.js'),
        uk: () => import('../toys/i18n/uk.js'),
    },
    beauty: {
        ar: () => import('../beauty/i18n/ar.js'),
        be: () => import('../beauty/i18n/be.js'),
        bg: () => import('../beauty/i18n/bg.js'),
        bs: () => import('../beauty/i18n/bs.js'),
        cs: () => import('../beauty/i18n/cs.js'),
        de: () => import('../beauty/i18n/de.js'),
        el: () => import('../beauty/i18n/el.js'),
        en: () => import('../beauty/i18n/en.js'),
        es: () => import('../beauty/i18n/es.js'),
        et: () => import('../beauty/i18n/et.js'),
        fr: () => import('../beauty/i18n/fr.js'),
        hr: () => import('../beauty/i18n/hr.js'),
        hu: () => import('../beauty/i18n/hu.js'),
        it: () => import('../beauty/i18n/it.js'),
        lt: () => import('../beauty/i18n/lt.js'),
        lv: () => import('../beauty/i18n/lv.js'),
        mk: () => import('../beauty/i18n/mk.js'),
        pl: () => import('../beauty/i18n/pl.js'),
        pt: () => import('../beauty/i18n/pt.js'),
        ro: () => import('../beauty/i18n/ro.js'),
        ru: () => import('../beauty/i18n/ru.js'),
        sk: () => import('../beauty/i18n/sk.js'),
        sl: () => import('../beauty/i18n/sl.js'),
        sq: () => import('../beauty/i18n/sq.js'),
        sr: () => import('../beauty/i18n/sr.js'),
        uk: () => import('../beauty/i18n/uk.js'),
    },
    electronics: {
        ar: () => import('../electronics/i18n/ar.js'),
        be: () => import('../electronics/i18n/be.js'),
        bg: () => import('../electronics/i18n/bg.js'),
        bs: () => import('../electronics/i18n/bs.js'),
        cs: () => import('../electronics/i18n/cs.js'),
        de: () => import('../electronics/i18n/de.js'),
        el: () => import('../electronics/i18n/el.js'),
        en: () => import('../electronics/i18n/en.js'),
        es: () => import('../electronics/i18n/es.js'),
        et: () => import('../electronics/i18n/et.js'),
        fr: () => import('../electronics/i18n/fr.js'),
        hr: () => import('../electronics/i18n/hr.js'),
        hu: () => import('../electronics/i18n/hu.js'),
        it: () => import('../electronics/i18n/it.js'),
        lt: () => import('../electronics/i18n/lt.js'),
        lv: () => import('../electronics/i18n/lv.js'),
        mk: () => import('../electronics/i18n/mk.js'),
        pl: () => import('../electronics/i18n/pl.js'),
        pt: () => import('../electronics/i18n/pt.js'),
        ro: () => import('../electronics/i18n/ro.js'),
        ru: () => import('../electronics/i18n/ru.js'),
        sk: () => import('../electronics/i18n/sk.js'),
        sl: () => import('../electronics/i18n/sl.js'),
        sq: () => import('../electronics/i18n/sq.js'),
        sr: () => import('../electronics/i18n/sr.js'),
        uk: () => import('../electronics/i18n/uk.js'),
    },
    default: {
        ar: () => import('../default/i18n/ar.js'),
        be: () => import('../default/i18n/be.js'),
        bg: () => import('../default/i18n/bg.js'),
        bs: () => import('../default/i18n/bs.js'),
        cs: () => import('../default/i18n/cs.js'),
        de: () => import('../default/i18n/de.js'),
        el: () => import('../default/i18n/el.js'),
        en: () => import('../default/i18n/en.js'),
        es: () => import('../default/i18n/es.js'),
        et: () => import('../default/i18n/et.js'),
        fr: () => import('../default/i18n/fr.js'),
        hr: () => import('../default/i18n/hr.js'),
        hu: () => import('../default/i18n/hu.js'),
        it: () => import('../default/i18n/it.js'),
        lt: () => import('../default/i18n/lt.js'),
        lv: () => import('../default/i18n/lv.js'),
        mk: () => import('../default/i18n/mk.js'),
        pl: () => import('../default/i18n/pl.js'),
        pt: () => import('../default/i18n/pt.js'),
        ro: () => import('../default/i18n/ro.js'),
        ru: () => import('../default/i18n/ru.js'),
        sk: () => import('../default/i18n/sk.js'),
        sl: () => import('../default/i18n/sl.js'),
        sq: () => import('../default/i18n/sq.js'),
        sr: () => import('../default/i18n/sr.js'),
        uk: () => import('../default/i18n/uk.js'),
    },
};
//# sourceMappingURL=loaders.gen.js.map